import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {BaseComponent} from '../basecomponent.js';

/* global customElements, Intl */

class FileStatsGrid extends BaseComponent {
	
	static get properties() {
		return {
			local: {type: Boolean},
			nodeId: {type: String}
		};
	}
	
	constructor() {
		super();
		
		this.local = false;
		
		var fileStatsGrid = this;
		setTimeout(function(){
			fileStatsGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var fileStatsGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				}			
			]
		});
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},			
			children: [				
				{						
					path: 'name',
					header: 'Name',					
					width: '9em'
				},
				{						
					path: 'directory',
					header: 'Directory',						
					'flex-grow': '1'						
				},
				{
					path: 'averageBytesPerSecond',
					header: 'Average Bytes/s',					
					width: '9em',
					'text-align': 'end',
					renderer: function(root, column, rowData) {										
						root.innerHTML = new Intl.NumberFormat().format(rowData.item.averageBytesPerSecond);
					}
				},
				{
					path: 'bytesStreamed',
					header: 'Bytes Streamed',					
					width: '9em',
					'text-align': 'end',
					renderer: function(root, column, rowData) {										
						root.innerHTML = new Intl.NumberFormat().format(rowData.item.bytesStreamed);
					}					
				},
				{
					path: 'input',
					header: 'Input/Output',					
					width: '9em',	
					'text-align': 'center',
					renderer: function(root, column, rowData) {										
						root.innerHTML = rowData.item.input ? 'Input' : 'Output';						
					}
				},
				{
					path: 'startDts',
					header: 'Start Date',					
					width: '9em',					
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.startDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				},
				{
					path: 'closedDts',
					header: 'Closed Date',					
					width: '9em',					
					renderer: function(root, column, rowData) {
						if (rowData.item.closedDts) {
							var date = TimeUtil.parseDate(rowData.item.closedDts);						
							root.innerHTML = TimeUtil.formatDateStandard(date);						
						}
					}
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];					
				}
			}
		});	
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid
			]
		});		
		fileStatsGrid.append(flexLayout);
		
		var actionRefresh = function() {
			var loadMask = grid.showLoading();			
			Service.getNodeService().getIOStats(fileStatsGrid.nodeId).then(function(data){
				loadMask.remove();				
				grid.items = data;
			});
		};
		actionRefresh();

	}	
	
};
customElements.define('dl-file-stats', FileStatsGrid);
